module.exports = __webpack_public_path__ + "img/WP2023-Icon-Seminars.af374aba.svg";